/**
 * Settings Card Component
 * 
 * A reusable card component for settings menu items.
 */

import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import { SettingsPreferences2Icon } from '@/components/icons'
import { cn } from '@/lib/utils'

interface SettingsCardProps {
  icon: React.ReactNode
  title: string
  description: string
  onClick: () => void
  className?: string
}

export function SettingsCard({ icon, title, description, onClick, className }: SettingsCardProps) {
  return (
    <Card 
      className={cn("pb-8 cursor-pointer hover:bg-muted/50 transition-colors", className)}
      onClick={onClick}
    >
      <CardHeader className="items-center gap-0">
        <CardTitle className="flex items-center justify-between w-full">
          <div className="flex items-center gap-3">
            {icon}
            {title}
          </div>
          <SettingsPreferences2Icon />
        </CardTitle>
        <p className="text-sm text-muted-foreground mt-2 w-full text-left">
          {description}
        </p>
      </CardHeader>
    </Card>
  )
}

